import { createFileRoute } from '@tanstack/react-router';
import RoutePreferenceSettings from '~/components/RoutePreferenceSettings';

export const Route = createFileRoute('/user-profile/route-preferences')({
  component: RoutePreferenceSettings,
});
